export default "__VITE_ASSET__CXVqupmW__"